export const SCREEN_PADDING_X = 16;
export const NO_TEXT = 'Note';
export const MARKER_RADIUS = 13;
